import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import GlassModal from './../../../v2/MUI_custom_component/Modal/GlassModal';
import AnimationModal from '../../../v2/MUI_custom_component/Modal/AnimationModal';
import OTPVerificationComponent from '../../Common/OTPVerification/OTPVerificationComponent';
import EpinCreation from '../../Common/EpinCreation/EpinCreation';
import { sendOTPAction, verifyOTPAction } from '../../Auth/Register/API/Action';
import { creteEPinAction } from '../../Auth/Register/API/Action';
import { encryptPassword } from '../../../v2/Utils/Encryption/NodeForgeEncryption';
import { OTP_PURPOSE_ENUM } from '../../Auth/Enum';
import successLottie from '../../../utils/Lottie/NewSuccess.json';

const OTPScreen = ({ open, onClose, onSuccess }) => {
    const [step, setStep] = useState('otp');
    const [vfcToken, setVfcToken] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const { mobile_number, loginUser } = useSelector((state) => {
        return {
            mobile_number: state.loginReducer.loginUser?.phone_no,
            loginUser: state.loginReducer.loginUser,
        };
    });
    const encryptedMobile = encryptPassword(mobile_number);
    useEffect(() => {
        if (open) {
            handleResendOTP();
            setStep('otp');
            setVfcToken(null);
            setShowSuccess(false);
        }
    }, [open]);
    const handleResendOTP = async () => {
        try {
            const payload = {
                mobile_number: encryptedMobile,
                purpose: OTP_PURPOSE_ENUM.RESET
            };
            
            const { error, message } = await sendOTPAction(payload);
            
            if (!error) {
                return { success: true, message };
            } else {
                return { success: false, message };
            }
        } catch (error) {
            return { success: false, message: 'Failed to send OTP. Please try again.' };
        }
    };

    const handleVerifyOTP = async (otp) => {
        const payload = {
            mobile_number: encryptedMobile,
            otp: encryptPassword(otp),
            purpose: OTP_PURPOSE_ENUM.RESET
        };
        const { data, error, message } = await verifyOTPAction(payload);
        if (!error) {
            return { success: true, data, message, vfc_token: data.vfc_token };
        } else {
            return { success: false, message };
        }
    };
    const handleCreateEpin = async ({ epin, confirmEpin }) => {
        setLoading(true);  
        const payload = {
            mobile_number: encryptedMobile,
            epin: epin,
            c_epin: confirmEpin,
            vfc_token: vfcToken,
            purpose: OTP_PURPOSE_ENUM.RESET,
            user_id: loginUser?.user_id,
        };
        try {
            const { data, error, message } = await creteEPinAction(payload);
            setLoading(false);
            
            if (!error) {
                onClose();
                setShowSuccess(true);
                return { success: true, message: message || 'e-Pin changed successfully', data };
            } else {
                return { success: false, message };
            }
        } catch (error) {
            setLoading(false);
            return { success: false, message: 'Failed to change e-Pin. Please try again.' };
        }
    };
    const handleOTPSuccess = (result) => {
        setVfcToken(result.vfc_token);
        setStep('createPin');
    };

    const handleEpinSuccess = () => {
        // Success handled by AnimationModal
    };

    const handleAnimationComplete = () => {
        setShowSuccess(false);
        onSuccess?.({ success: true, message: 'e-Pin changed successfully' });
        onClose();
    };

    const getModalTitle = () => {
        return step === 'otp' ? 'Enter OTP' : 'Reset e-Pin';
    };

    return (
        <>
            <GlassModal
                open={open}
                onClose={onClose}
                title={getModalTitle()}
                scrollable={true}
                maxWidth="500px"
                zIndex={2}
                pt={4}
            >
                {step === 'otp' ? (
                    <OTPVerificationComponent
                        mobileNumber={mobile_number}
                        onVerify={handleVerifyOTP}
                        onResend={handleResendOTP}
                        purpose="changePin"
                        customMessage={`Please enter OTP sent to Mobile Number ${mobile_number}`}
                        onAnimationComplete={handleOTPSuccess}
                        onError={(error) => {
                            console.error('OTP verification error:', error);
                        }}
                    />
                ) : (
                    <EpinCreation
                        title="Create New e-Pin"
                        onCreateEpin={handleCreateEpin}
                        onSuccess={handleEpinSuccess}
                        onError={(error) => {
                            console.error('e-Pin creation error:', error);
                        }}
                        CancelButtonhandler={() => {
                            onClose();
                        }}
                        CancelButtonLabel="Cancel"
                        buttonLabel="Confirm"
                        loading={loading}
                    />
                )}
            </GlassModal>
            <AnimationModal
                maxWidth = {{xs: '500px', md: '610px' }}
                width = {{ xs: '500px', md: '610px' }}
                open={showSuccess}
                onClose={() => setShowSuccess(false)}
                title='Successful!'
                subtitle='e-Pin changed successfully.'
                onAnimationComplete={handleAnimationComplete}
                loop={false}
                animationData={successLottie}
            />
        </>
    );
};

export default OTPScreen;